import { patchSystemInformation } from "../api/EnzianDataApi";
import { handleStoreError } from "./GeneralStore";
import { writable } from "svelte/store";
/**
 * GENERAL DATA CONTAINERS
 */
export const systemInformationStore = writable(null);
export const licenceEndKey = 'licenceEndingChecked';
export const renewBus = writable(null);
export async function patchSystemInformationStore(request) {
    try {
        //Make the request
        const response = await patchSystemInformation(request);
        //Set the information back to the ui
        systemInformationStore.set(response);
    }
    catch (err) {
        handleStoreError("system.err_update_system_information", err);
    }
}
